import { render } from "./ModalExchange.vue?vue&type=template&id=dd77f6aa"
import script from "./ModalExchange.vue?vue&type=script&lang=js"
export * from "./ModalExchange.vue?vue&type=script&lang=js"

import "./ModalExchange.vue?vue&type=style&index=0&id=dd77f6aa&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__